import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var mini = designTokenFonts.mini,
  bodyBold = designTokenFonts.bodyBold;
var colours = tokens.colors,
  spacing = tokens.spacing;
export var agentCard = /*#__PURE__*/css(mini, ";display:flex;justify-content:flex-start;align-items:center;gap:", spacing.s, ";margin-bottom:", spacing.s, ";", media('>=tablet'), "{align-items:flex-start;}");
export var agentDetailsWrapper = /*#__PURE__*/css("display:flex;flex-direction:row;align-items:center;justify-content:space-between;gap:", spacing.xs, ";width:100%;overflow:hidden;max-width:100%;", media('>=tablet'), "{flex-direction:column;align-items:flex-start;justify-content:flex-start;gap:", spacing.xs, ";}");
export var agentDetailsTextInnerWrapper = {
  name: "1742157",
  styles: "overflow:hidden;max-width:100%;"
};
export var agentDetailsText = {
  name: "1742157",
  styles: "overflow:hidden;max-width:100%;"
};
var fixedSize = {
  name: "1sh75vq",
  styles: "flex-grow:0;flex-shrink:0;"
};
export var avatar = /*#__PURE__*/css("width:40px;height:40px;", media('>=tablet'), "{width:60px;height:60px;}");
export var button = /*#__PURE__*/css(fixedSize, ";display:block;min-width:100px;min-height:34px;");
export var text = /*#__PURE__*/css("flex-grow:1;color:", colours.neutral.medium.default, ";text-decoration:none;max-width:100%;overflow:hidden;", media('>=tablet'), "{display:inline-block;vertical-align:top;}");
export var name = /*#__PURE__*/css("display:block;", bodyBold, " color:", colours.neutral.heavy.default, ";max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
export var privateLister = /*#__PURE__*/css(mini, " color:", colours.neutral.medium.default, ";");
export var callButton = {
  name: "ifp62s",
  styles: "min-width:100px;min-height:34px;"
};